import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const RankViewModal = ({ show, handleClose, data, currentRank }) => {
  const { t } = useTranslation();
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title as={"h5"}>{t("rank")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="rank-timeline">
          <div className="history-tl-container">
            <ul className="tl">
              {data
  ?.filter((item, index, self) => 
    index === self.findIndex((t) => t.id === item.id)
  )
  .map((item, index) => (
    <li
      className={`tl-item ${
        item.id === currentRank ? "active" : ""
      } ${currentRank > item.id ? "passed" : ""}`}
      key={item.id}
    >
      <div className="item-title">{item.name}</div>
      <div className="timestamp">
        {item.criteria.map((criterion, i) => (
          <p 
            className={`${currentRank > item.id ? "passed" : "active"}`} 
            key={i}
          >
            {`${t(criterion.name)}: ${
              Array.isArray(criterion.value)
                ? criterion.value.length !== 0
                  ? criterion.value
                      .map((val) => `${val.label}: ${val.value}`)
                      .join(", ")
                  : 0
                : criterion.value
            }`}
          </p>
        ))}
      </div>
    </li>
  ))}
            </ul>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RankViewModal;
